import fetch from "node-fetch";

const fetchProductReviews = async (sku) => {
	try {
		const response = await fetch(`https://api.reviews.io/product/review?store=every-foods.com&sku=${sku}`);
		const data = await response.json();
		const { average, count } = data.stats;
		return { average: +average, count };
	} catch (error) {
		console.error(error);
		return null;
	}
};

export default fetchProductReviews;
